export enum CollectionsEnum {
	UNIT = "units",
	INVENTORY_ITEM = "inventory",
	CATEGORY = "categories",
	BIN = "bins",
	LISTING = "listings",
	SALE = "sales"
}

export enum SubscriptionTypeEnum {
	Free = "free",
	Basic = "basic",
	Premium = "premium",
	Enterprise = "enterprise"
}
